import { Product } from "../types/product";

class StockUtil {
  check(product: Product, qty: number = -1) {
    return true
  }
}

export default new StockUtil;